import { z } from '@/utils/zod'

import { LocalAuthProviderTypeSchema } from './LocalAuthProvider'
import { GoogleAuthProviderTypeSchema } from './GoogleAuthProvider'
import { MicrosoftAuthProviderTypeSchema } from './MicrosoftAuthProvider'

export const AuthProviderSchema = z.enum([
    LocalAuthProviderTypeSchema.value,
    GoogleAuthProviderTypeSchema.value,
    MicrosoftAuthProviderTypeSchema.value,
])

export type AuthProvider = z.infer<typeof AuthProviderSchema>

export const isAuthProvider = (value: string): value is AuthProvider => {
    return AuthProviderSchema.options.includes(value as AuthProvider)
}
